import React from 'react';

const IcSearch = () => <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>;
const IcClock = () => <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>;
const IcTrendUp = () => <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" /></svg>;

const YOUR_180 = ['Pitch deck quality', 'Market opportunity', 'Thesis alignment', 'Founder chemistry', 'Product-market fit', 'Competitive positioning'];
const OTHER_180 = ['Corporate governance', 'IP ownership & assignment', 'Cap table accuracy', 'Founder agreements', 'Financial records vs. narrative', 'Regulatory compliance'];

const BENEFITS = [
    { bg: '#4A67FF', icon: <IcSearch />, title: '360° view at application', text: 'Every applicant gets a free Diligentsia account. Governance gaps, IP issues, and documentation holes surface automatically before your analysts spend serious time.' },
    { bg: '#FC7785', icon: <IcClock />, title: 'Preliminary DD before IC', text: 'Concurrent corporate readiness alongside your market evaluation. Series A compressed from 10–30 weeks to 6–15 weeks. ~£25,000 saved (mid-scenario).' },
    { bg: '#6E56CF', icon: <IcTrendUp />, title: 'Always on post-investment', text: 'Portfolio companies stay on platform. Governance stays clean. Unified dashboard for portfolio managers. Every next round or exit starts from a position of strength.' },
];

const EFFECTS = [
    { img: require('../../../../images/landing-pages/VC/effect-1-icon.jpg'), eyebrow: 'Effect 1', title: 'Fewer bad investments', text: 'A 360-degree view at triage means governance gaps, IP issues, and undisclosed founder disputes are visible at week one — not week 12. Avoiding your worst two investments in a ten-company portfolio has greater impact on returns than optimising any other single variable.' },
    { img: require('../../../../images/landing-pages/VC/effect-2-icon.jpg'), eyebrow: 'Effect 2', title: 'Higher exit valuations', text: 'At exit, buyers look for reasons to chip the price. Missing governance documentation is professional justification for a 10% reduction. On a £5M exit, preventing that chip is worth £500,000. A continuously-maintained Diligence Pack removes that leverage.' },
];

const VCFirmsTab = () => (
    <div role="tabpanel">

        <section className="lp-section" style={{ background: '#fff' }}>
            <div className="lp-container">
                <h2 className="lp-h2" data-lp-reveal style={{ maxWidth: '780px' }}>A 360-degree view on every deal. Free to your firm.</h2>
                <p className="lp-sub" style={{ marginBottom: 52 }} data-lp-reveal data-lp-delay="60">You already assess market, thesis fit, and founder quality. That is 180 degrees. Diligentsia gives you the other 180 — automatically, at the point of application.</p>

                <div className="lp-vc-split" data-lp-reveal data-lp-delay="120">
                    <div className="lp-vc-split-col" style={{ background: '#fff' }}>
                        <div className="lp-vc-split-head">
                            <img src={require('../../../../images/landing-pages/VC/your-180-degrees-icon.jpg')} alt="Your 180 degrees" />
                            <div>
                                <div className="ttl" style={{ color: '#FC7785' }}>Your 180 degrees</div>
                                <div className="sub">What you already assess</div>
                            </div>
                        </div>
                        <div className="lp-vc-split-list">
                            {YOUR_180.map((t, i) => <div key={i}><span style={{ color: '#FC7785' }}>→</span> {t}</div>)}
                        </div>
                    </div>
                    <div className="lp-vc-split-col" style={{ background: '#eef1ff' }}>
                        <div className="lp-vc-split-head">
                            <img src={require('../../../../images/landing-pages/VC/other-180-degrees-icon.jpg')} alt="The other 180 degrees" />
                            <div>
                                <div className="ttl" style={{ color: '#4A67FF' }}>The other 180 degrees</div>
                                <div className="sub">What Diligentsia surfaces</div>
                            </div>
                        </div>
                        <div className="lp-vc-split-list">
                            {OTHER_180.map((t, i) => <div key={i}><span style={{ color: '#4A67FF' }}>✓</span> {t}</div>)}
                        </div>
                    </div>
                    <div className="lp-vc-split-banner">
                        <p>Together: a complete 360-degree picture before your Investment Committee meets — not after it has issued a term sheet.</p>
                    </div>
                </div>
            </div>
        </section>

        <section className="lp-section" style={{ background: '#FBFBFD' }}>
            <div className="lp-container">
                <h2 className="lp-h2" data-lp-reveal style={{ maxWidth: '580px' }}>Three ways Diligentsia changes your process.</h2>
                <p className="lp-sub" style={{ marginBottom: 52 }} data-lp-reveal data-lp-delay="60">From first application to portfolio exit — always working.</p>
                <div className="lp-vc-benefits">
                    {BENEFITS.map((b, i) => (
                        <div className="lp-vc-benefit" key={i} style={{ background: b.bg }} data-lp-reveal data-lp-delay={i * 100}>
                            <div className="lp-vc-benefit-icon">{b.icon}</div>
                            <h3>{b.title}</h3>
                            <p>{b.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>

        <section className="lp-vc-effects">
            <div className="lp-container">
                <h2 className="lp-h2" data-lp-reveal>Two effects. Both move the needle on returns.</h2>
                <div className="lp-vc-effects-grid">
                    {EFFECTS.map((e, i) => (
                        <div className="lp-vc-effect-card" key={i} data-lp-reveal data-lp-delay={i * 100}>
                            <div className="lp-vc-effect-head">
                                <img src={e.img} alt={e.title} />
                                <div>
                                    <div className="eyebrow">{e.eyebrow}</div>
                                    <h3>{e.title}</h3>
                                </div>
                            </div>
                            <p>{e.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>

    </div>
);

export default VCFirmsTab;
